<template>
  <v-container fluid>

    <v-snackbar
      v-model="snackbar"
      :color="snackbarColor"
      :top="true"
      :right="true"
      :timeout="0"
      absolute
      auto-height
    >
      {{ message }}
      <v-btn
        dark
        flat
        @click="snackbar = false"
      >
        CLOSE
      </v-btn>
    </v-snackbar>
    <!--<v-snackbar-->
    <!--  v-model="snackbar"-->
    <!--  :color="snackbarColor"-->
    <!--  top-->
    <!--  right-->
    <!--  :timeout="-1"-->
    <!--  >-->
    <!--  {{ message }}-->
    <!--  <v-btn-->
    <!--    dark-->
    <!--    text-->
    <!--    @click="snackbar = false"-->
    <!--  >-->
    <!--    CLOSE-->
    <!--  </v-btn>-->

    <v-layout class="mt-14">
      <v-flex xs12>
        <div :class="paginatedFiles.length === 7 ? 'viewfarmer_box' : 'viewfarmer_box_empty'">
          <v-card-text>
            <v-layout>
              <v-flex xs3>
                <span class="accent--text" style="font-size: 14px; font-weight:700;"> Pending Farmer Payment Schedules </span>
              </v-flex>
              <v-spacer>
              </v-spacer>
              <v-flex xs3>
                <v-text-field label="Search" v-model="search">
                </v-text-field>
              </v-flex>
            </v-layout>
            <table class="table">
              <thead class="thead">
              <tr>
                <th scope="col">Farmer Society</th>
                <th scope="col">Season</th>
                <th scope="col">Total Cherry</th>
                <th scope="col">Total Amount in KES Account</th>
                <th scope="col">Communal Rate</th>
                <th scope="col">Cycle</th>
                <th scope="col">Actions</th>
              </tr>
              </thead>
              <tbody>
              <tr v-for="paymentSchedule in filteredList" v-bind:key="paymentSchedule.id">
                <td> {{ paymentSchedule.organisation?.organisationName  }} </td>
                <td> {{ paymentSchedule.season}} </td>
                <td> {{ paymentSchedule.totalCherryWeight}} </td>
                <td> {{ paymentSchedule.totalKesAmount }} </td>
                <td>{{ paymentSchedule.commissionRate }}</td>
                <td>{{ paymentSchedule.paymentCycle?.cycle}}</td>
                <td class="actions">
                  <v-menu offset-y>
                    <template v-slot:activator="{ on }">
                      <v-btn
                        color="primary"
                        v-on="on"
                        text
                        icon
                        class="actions"
                      >
                        <v-icon class="secondary--text"> more_horiz </v-icon>
                      </v-btn>
                    </template>
                    <v-list>
                      <v-list-item :to="`/farmers/schedule/details/approve/${paymentSchedule.id}`">
                        <v-list-item-title> View Schedule</v-list-item-title>
                      </v-list-item>
                      <v-list-item >
                        <v-list-item-title @click ="showApproveDialog(paymentSchedule)"> Approve</v-list-item-title>
                      </v-list-item>
                      <v-list-item >
                        <v-list-item-title @click="showRejectDialog(paymentSchedule)"> Reject</v-list-item-title>
                      </v-list-item>
                    </v-list>
                  </v-menu>
                </td>
              </tr>
              </tbody>
            </table>
          </v-card-text>
          <v-card-actions>
            <span class="paginationtext"> Showing {{ page }} of {{ numberOfLinks }} pages </span>
            <v-spacer></v-spacer>
            <v-pagination
              v-model="page"
              :length="numberOfLinks"
              color="secondary"
                class="accent--text logoutbtn"
            ></v-pagination>
          </v-card-actions>
        </div>
      </v-flex>
    </v-layout>
    <v-dialog v-model="approveDialog" persistent width="500">
      <v-card>
        <v-card-title class="headline primary--text">Approve Payment Schedule</v-card-title>
        <v-card-text>
          <v-flex xs8>
            <h5> Are you sure you want to approve the payment Schedule? </h5>
          </v-flex>
        </v-card-text>
        <v-card-actions>
          <v-btn color="primary" flat @click="cancelDialog">Cancel</v-btn>
          <v-spacer></v-spacer>
          <v-btn color="primary" @click="approveRecord">Approve</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="rejectDialog" persistent width="500">
      <v-card>
        <v-card-title class="headline primary--text">Reject Payment Schedule</v-card-title>
        <v-card-text>
          <v-flex xs8>
            <h5> Are you sure you want to reject the payment Schedule? </h5>
          </v-flex>
        </v-card-text>
        <v-card-actions>
          <v-btn color="primary" flat @click="cancelRejectDialog">Cancel</v-btn>
          <v-spacer></v-spacer>
          <v-btn color="primary" @click="rejectRecord">Reject</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>
<script>
import axios from 'axios'
import config from '../../../config'
import store from '../../../store'

export default {
	name: 'ApprovePaymentSchedule',
	data: function () {
		return {
			valid: true,
			message: '',
			snackbar: false,
			snackbarColor: '',
			farmers: [],
			paymentSchedule: {
				firstPay: false,
				secondPay: false,
				lastPay: false
			},
			cuurentCycle: '',
			communalPayments: [],
			totalFarmers: 0,
			pagination: { sortBy: 'id', descending: true },
			search: '',
			paginatedFiles: [],
			numberOfLinks: 0,
			numberOfItemsPerPage: 7,
			page: 1,
			farmerBankDetail: null,
			editDialog: false,
			bankDetailsDialog: false,
			farmer: { farmerBankDetail: { bank: {} } },
			banks: [],
			permissions: [],
			approveDialog: false,
			rejectDialog: false,
			item: {},
      organisationId: ''
		}
	},
	mounted () {
    this.theUser = JSON.parse(localStorage.getItem('user'))
    console.log('user ===>> ', this.theUser)
    this.organisationType = this.theUser.organisation.organisationType.name
    this.organisationId = this.theUser.organisation.id
		this.getCommunalPayments()
		this.permissions = store.state.user.roleId.permissions
	},
	watch: {
		communalPayments () {
			this.paginatedFiles = this.paginationMethod(this.communalPayments, 1, this.numberOfItemsPerPage)
			this.numberOfLinks = Math.ceil(this.communalPayments.length / this.numberOfItemsPerPage)
		},
		page: function (val) {
			this.paginatedFiles = this.paginationMethod(this.communalPayments, val, this.numberOfItemsPerPage)
		}
	},
	computed: {
		filteredList: function () {
			if (this.search === '') {
				return this.paginatedFiles
			} else {
				return this.communalPayments.filter(communalPayment => { return (communalPayment.season !== null ? communalPayment.season.toLowerCase().includes(this.search.toLowerCase()) : ''.toLowerCase().includes(this.search.toLowerCase())) || (communalPayment.organisation?.organisationName === null ? ''.toLowerCase().includes(this.search.toLowerCase()) : communalPayment.organisation?.organisationName.toLowerCase().includes(this.search.toLowerCase())) })
			}
		}
	},
	methods: {
		paginationMethod (items, pageNumber, limitPerPage) {
			pageNumber = pageNumber - 1
			const from = pageNumber * limitPerPage
			let to = (pageNumber + 1) * limitPerPage
			if (to >= items.length) {
				to = items.length
			}
			return items.slice(from, to)
		},
		hasPerm (permission) {
			return this.permissions.includes(permission)
		},

		getCommunalPayments () {
			const url = config.serverURI + '/payment/fetchUnapprovedCommunalPayments/'+ this.organisationId
			axios.get(url)
				.then(response => {
					this.communalPayments = response.data.data
					console.log('communal payments ', this.communalPayments)
				})
				.catch(error => {
					console.log('error', error.response)
				})
		},
		getCurrentCycle (item) {
			if (item.firstPay && !item.secondPay && !item.lastPay) {
				return '1'
			} else if (item.firstPay && item.secondPay && !item.lastPay) {
				return '2'
			} else if (item.firstPay && item.secondPay && item.lastPay) {
				return '3'
			} else {
				return '0'
			}
		},
		showApproveDialog (item) {
			this.item = item
			this.approveDialog = true
		},
		cancelDialog () {
			this.approveDialog = false
		},
		cancelRejectDialog () {
			this.rejectDialog = false
		},
		showRejectDialog (item) {
			this.item = item
			this.rejectDialog = true
		},
		approveRecord () {
			const url = config.serverURI + '/payment/approveFarmerSchedule/' + this.organisationId
			axios.post(url, {
				commId: this.item?.id,
				action: 'APPROVE'

			})
				.then(response => {
					if (response.data.error !== false) {
						this.message = response.data.message
						this.snackbar = true
						this.snackbarColor = 'error'
						console.log('Error is ' + this.message)
						this.approveDialog = false
						return
					}
					this.message = response.data.message
					this.snackbar = true
					this.snackbarColor = 'primary'
					this.approveDialog = false
					this.getCommunalPayments()
				})
				.catch(error => {
					console.log('error', error.response)
					this.message = 'Error occurred while processing your request'
					this.snackbar = true
					this.snackbarColor = 'error'
					this.approveDialog = false
				})
		},
		rejectRecord () {
			const url = config.serverURI + '/payment/approveFarmerSchedule/' + this.organisationId
			axios.post(url, {
				commId: this.item?.id,
				action: 'REJECT'

			})
				.then(response => {
					if (response.data.error !== false) {
						this.message = response.data.message
						this.snackbar = true
						this.snackbarColor = 'error'
						console.log('Error is ' + this.message)
						this.rejectDialog = false
						return
					}
					this.message = response.data.message
					this.snackbar = true
					this.snackbarColor = 'primary'
					this.rejectDialog = false
					this.getCommunalPayments()
				})
				.catch(error => {
					console.log('error', error.response)
					this.message = 'Error occurred while processing your request'
					this.snackbar = true
					this.snackbarColor = 'error'
					this.rejectDialog = false
				})
		}
	}
}

</script>
<style>
.viewfarmer_box_empty {
  position: relative;
  background: #fff;
  border: 1px solid #707070;
}
.viewfarmer_box {
  position: relative;
  background: #fff;
  border: 1px solid #707070;
}
.catalogue_box:after, .catalogue_box:before {
  right: 100%;
  top: 17%;
  border: solid transparent;
  content: " ";
  height: 0;
  width: 0;
  position: absolute;
  pointer-events: none;
}

.catalogue_box:after {
  border-color: rgba(255, 255, 255, 0);
  border-right-color: #fff;
  border-width: 20px;
  margin-top: -20px;
}
.catalogue_box:before {
  border-color: rgba(112, 112, 112, 0);
  border-right-color: #707070;
  border-width: 21px;
  margin-top: -21px;
}

.thead {
  background-color: #00513B !important;
  color: white;
  font-size: 12px;
}

.table  tbody  tr >  td.actions {
  font-size: 20px !important;
  color: #733D29 !important;
  padding-top: 0px;
}
.pagination {
  background-color: red;
}
.paginationtext {
  color: #733D29;
}

.pagination>li>a,
.pagination>li>span {
  border: 1px solid #F2D0A7;
  color: #733D29;
}
.pagination>li.active>.page-link {
  background: #00513B;
  color: #fff;
}
</style>
